var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 94,
    viewBox: "0 0 40 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.6599C0 3.87717 3.87717 0 8.6599 0H31.304C36.0867 0 39.9639 3.87717 39.9639 8.6599V87.5035C39.9639 89.1475 38.8444 90.5753 37.2369 90.9201C33.2123 91.7833 25.5576 93.2492 19.982 93.2492C14.4063 93.2492 6.7516 91.7833 2.72704 90.9201C1.11956 90.5753 0 89.1475 0 87.5035V8.6599Z",
    fill: "#616161"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.34511,
    width: 7.17436,
    height: 1.02735,
    rx: 0.513673,
    transform: "matrix(0.735545 0.677476 -0.735545 0.677476 33.8871 1.09281)",
    fill: "#F0F0F2",
    stroke: "#F0F0F2",
    strokeWidth: 0.509406
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.34511,
    width: 7.17435,
    height: 1.02735,
    rx: 0.513673,
    transform: "matrix(-0.735545 0.677475 0.735545 0.677475 6.99658 1.58356)",
    fill: "#F0F0F2",
    stroke: "#F0F0F2",
    strokeWidth: 0.509406
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3773,
    y: 1.2362,
    width: 20.2718,
    height: 0.962951,
    rx: 0.254703,
    fill: "#F0F0F2",
    stroke: "#F0F0F2",
    strokeWidth: 0.509406
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.39558,
    y: 8.96754,
    width: 0.266617,
    height: 15.9293,
    fill: "#F0F0F2",
    stroke: "#F0F0F2",
    strokeWidth: 0.266617
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35.8352,
    y: 8.96754,
    width: 0.266617,
    height: 15.9293,
    fill: "#F0F0F2",
    stroke: "#F0F0F2",
    strokeWidth: 0.266617
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5146 25.0298C14.7052 25.0125 6.53909 26.8086 3.69149 27.48C3.12925 27.6126 2.79967 28.1897 2.96282 28.7438L6.65217 41.2743C6.80591 41.7964 7.33905 42.1077 7.87009 41.9884C10.1752 41.4701 16.2197 40.2137 20.5146 40.2441C24.6333 40.2733 30.4115 41.4864 32.6412 41.9908C33.1659 42.1095 33.6946 41.8074 33.8552 41.294L37.7776 28.7558C37.952 28.1981 37.6237 27.6102 37.0548 27.476C34.2219 26.8079 26.2197 25.0468 20.5146 25.0298Z",
    fill: "#F0F0F2",
    stroke: "#F0F0F2",
    strokeWidth: 0.254703
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6344 53.9865L37.2987 53.005V37.7906L34.6344 44.1708V53.9865Z",
    fill: "#F0F0F2",
    stroke: "#F0F0F2",
    strokeWidth: 0.254703
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79602 53.9865L2.13176 53.005V37.7906L4.79602 44.1708V53.9865Z",
    fill: "#F0F0F2",
    stroke: "#F0F0F2",
    strokeWidth: 0.254703
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3044 84.9813V81.1419C33.3044 80.8103 32.9966 80.5648 32.6737 80.6407C30.7413 81.0951 24.7752 82.4149 20.516 82.4519C16.0697 82.4905 9.81264 81.109 7.82582 80.6412C7.50283 80.5651 7.19464 80.8107 7.19464 81.1425V84.9941C7.19464 85.2301 7.35346 85.4341 7.58369 85.4858C9.2365 85.8568 15.8067 87.2526 20.516 87.1144C24.979 86.9834 31.2633 85.7991 32.9014 85.4771C33.1387 85.4305 33.3044 85.2231 33.3044 84.9813Z",
    fill: "#F0F0F2",
    stroke: "#F0F0F2",
    strokeWidth: 0.254703
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92667 89.8968V88.7293C6.92667 88.5002 6.77375 88.2993 6.55293 88.2383L2.09386 87.0062C1.84454 86.9373 1.59814 87.1249 1.59814 87.3835C1.59814 87.5212 1.67043 87.6487 1.78852 87.7194L6.1556 90.3339C6.49514 90.5372 6.92667 90.2926 6.92667 89.8968Z",
    fill: "#F0F0F2",
    stroke: "#F0F0F2",
    strokeWidth: 0.254703
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5711 89.8968V88.7293C33.5711 88.5002 33.7241 88.2993 33.9449 88.2383L38.4039 87.0062C38.6533 86.9373 38.8997 87.1249 38.8997 87.3835C38.8997 87.5212 38.8274 87.6487 38.7093 87.7194L34.3422 90.3339C34.0027 90.5372 33.5711 90.2926 33.5711 89.8968Z",
    fill: "#F0F0F2",
    stroke: "#F0F0F2",
    strokeWidth: 0.254703
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6344 56.1949L37.2987 55.2133V74.354L34.6344 71.6546V56.1949Z",
    fill: "#F0F0F2",
    stroke: "#F0F0F2",
    strokeWidth: 0.254703
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79602 56.1949L2.13176 55.2133V74.354L4.79602 71.6546V56.1949Z",
    fill: "#F0F0F2",
    stroke: "#F0F0F2",
    strokeWidth: 0.254703
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/Car.0b1cb8483f76df13b4829f2cffd61f03.svg";
export { ForwardRef as ReactComponent };